import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/event-1.jpg'
import _imports_1 from '@/assets/images/user-6.jpg'
import _imports_2 from '@/assets/images/user-7.jpg'
import _imports_3 from '@/assets/images/user-8.jpg'
import _imports_4 from '@/assets/images/user-9.jpg'
import _imports_5 from '@/assets/images/event-2.jpg'
import _imports_6 from '@/assets/images/user-10.jpg'
import _imports_7 from '@/assets/images/user-11.jpg'
import _imports_8 from '@/assets/images/event-3.jpg'
import _imports_9 from '@/assets/images/user-12.jpg'
import _imports_10 from '@/assets/images/user-13.jpg'
import _imports_11 from '@/assets/images/user-14.jpg'
import _imports_12 from '@/assets/images/event-4.jpg'
import _imports_13 from '@/assets/images/user-15.jpg'
import _imports_14 from '@/assets/images/event-5.jpg'
import _imports_15 from '@/assets/images/user-16.jpg'
import _imports_16 from '@/assets/images/user-17.jpg'
import _imports_17 from '@/assets/images/event-6.jpg'
import _imports_18 from '@/assets/images/user-18.jpg'
import _imports_19 from '@/assets/images/user-19.jpg'
import _imports_20 from '@/assets/images/user-20.jpg'
import _imports_21 from '@/assets/images/event-7.jpg'
import _imports_22 from '@/assets/images/user-21.jpg'
import _imports_23 from '@/assets/images/event-8.jpg'
import _imports_24 from '@/assets/images/user-22.jpg'
import _imports_25 from '@/assets/images/user-23.jpg'
import _imports_26 from '@/assets/images/user-24.jpg'
import _imports_27 from '@/assets/images/user-25.jpg'
import _imports_28 from '@/assets/images/event-9.jpg'
import _imports_29 from '@/assets/images/user-26.jpg'
import _imports_30 from '@/assets/images/user-27.jpg'
import _imports_31 from '@/assets/images/event-10.jpg'
import _imports_32 from '@/assets/images/user-28.jpg'
import _imports_33 from '@/assets/images/user-29.jpg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "position-relative mb-3" }
const _hoisted_6 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_7 = { class: "ms-m-15" }
const _hoisted_8 = { class: "ms-m-15" }
const _hoisted_9 = { class: "ms-m-15" }
const _hoisted_10 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_11 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_12 = { class: "card-body p-4" }
const _hoisted_13 = { class: "position-relative mb-3" }
const _hoisted_14 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_15 = { class: "ms-m-15" }
const _hoisted_16 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_17 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_18 = { class: "card-body p-4" }
const _hoisted_19 = { class: "position-relative mb-3" }
const _hoisted_20 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_21 = { class: "ms-m-15" }
const _hoisted_22 = { class: "ms-m-15" }
const _hoisted_23 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_24 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_25 = { class: "card-body p-4" }
const _hoisted_26 = { class: "position-relative mb-3" }
const _hoisted_27 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_28 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_29 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_30 = { class: "card-body p-4" }
const _hoisted_31 = { class: "position-relative mb-3" }
const _hoisted_32 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_33 = { class: "ms-m-15" }
const _hoisted_34 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_35 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_36 = { class: "card-body p-4" }
const _hoisted_37 = { class: "position-relative mb-3" }
const _hoisted_38 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_39 = { class: "ms-m-15" }
const _hoisted_40 = { class: "ms-m-15" }
const _hoisted_41 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_42 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_43 = { class: "card-body p-4" }
const _hoisted_44 = { class: "position-relative mb-3" }
const _hoisted_45 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_46 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_47 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_48 = { class: "card-body p-4" }
const _hoisted_49 = { class: "position-relative mb-3" }
const _hoisted_50 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_51 = { class: "ms-m-15" }
const _hoisted_52 = { class: "ms-m-15" }
const _hoisted_53 = { class: "ms-m-15" }
const _hoisted_54 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_55 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_56 = { class: "card-body p-4" }
const _hoisted_57 = { class: "position-relative mb-3" }
const _hoisted_58 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_59 = { class: "ms-m-15" }
const _hoisted_60 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_61 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_62 = { class: "card-body p-4" }
const _hoisted_63 = { class: "position-relative mb-3" }
const _hoisted_64 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_65 = { class: "ms-m-15" }
const _hoisted_66 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_67 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_68 = { class: "card-body p-4" }
const _hoisted_69 = { class: "position-relative mb-3" }
const _hoisted_70 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_71 = { class: "ms-m-15" }
const _hoisted_72 = { class: "ms-m-15" }
const _hoisted_73 = { class: "col-xl-4 col-xxl-3 col-sm-6" }
const _hoisted_74 = { class: "card bg-white border-0 rounded-3 mb-4 transition-y" }
const _hoisted_75 = { class: "card-body p-4" }
const _hoisted_76 = { class: "position-relative mb-3" }
const _hoisted_77 = { class: "ps-0 mb-4 list-unstyled d-flex align-items-center" }
const _hoisted_78 = { class: "ms-m-15" }
const _hoisted_79 = { class: "ms-m-15" }
const _hoisted_80 = { class: "ms-m-15" }
const _hoisted_81 = { class: "col-lg-12" }
const _hoisted_82 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_83 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Annual Conference 2024 ", -1)
            ]))]),
            _: 1
          }),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "1156")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "85",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"85%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: _imports_5,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode(" Leadership Summit 2024 ", -1)
            ]))]),
            _: 1
          }),
          _cache[14] || (_cache[14] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("img", {
                    src: _imports_6,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("img", {
                    src: _imports_7,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "556")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "30",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"30%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createElementVNode("img", {
                  src: _imports_8,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode(" Product Launch Webinar ", -1)
            ]))]),
            _: 1
          }),
          _cache[22] || (_cache[22] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_20, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("img", {
                    src: _imports_9,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("img", {
                    src: _imports_10,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_22, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("img", {
                    src: _imports_11,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "356")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "60",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"60%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createElementVNode("img", {
                  src: _imports_12,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode("AI in Healthcare Symposium", -1)
            ]))]),
            _: 1
          }),
          _cache[28] || (_cache[28] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_27, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createElementVNode("img", {
                    src: _imports_13,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[29] || (_cache[29] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "3226")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "70",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"70%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createElementVNode("img", {
                  src: _imports_14,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode(" Tech Summit 2024 ", -1)
            ]))]),
            _: 1
          }),
          _cache[35] || (_cache[35] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_32, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("img", {
                    src: _imports_15,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_33, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                  _createElementVNode("img", {
                    src: _imports_16,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "4109")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "50",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"50%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
              _createTextVNode(" Startup Pitch Day ", -1)
            ]))]),
            _: 1
          }),
          _cache[43] || (_cache[43] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_38, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                  _createElementVNode("img", {
                    src: _imports_18,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_39, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                  _createElementVNode("img", {
                    src: _imports_19,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_40, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                  _createElementVNode("img", {
                    src: _imports_20,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[44] || (_cache[44] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "432")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "40",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"40%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                _createElementVNode("img", {
                  src: _imports_21,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
              _createTextVNode(" Workshop: Digital Marketing ", -1)
            ]))]),
            _: 1
          }),
          _cache[49] || (_cache[49] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_45, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                  _createElementVNode("img", {
                    src: _imports_22,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[50] || (_cache[50] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "1728")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "60",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"60%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                _createElementVNode("img", {
                  src: _imports_23,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[52] || (_cache[52] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, " $120 ")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
              _createTextVNode(" Charity Gala Dinner ", -1)
            ]))]),
            _: 1
          }),
          _cache[58] || (_cache[58] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_50, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                  _createElementVNode("img", {
                    src: _imports_24,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_51, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                  _createElementVNode("img", {
                    src: _imports_25,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_52, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                  _createElementVNode("img", {
                    src: _imports_26,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_53, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                  _createElementVNode("img", {
                    src: _imports_27,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[59] || (_cache[59] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "1306")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "90",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"90%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                _createElementVNode("img", {
                  src: _imports_28,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[61] || (_cache[61] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, "$120")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
              _createTextVNode("Web Development Seminar", -1)
            ]))]),
            _: 1
          }),
          _cache[65] || (_cache[65] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_58, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                  _createElementVNode("img", {
                    src: _imports_29,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_59, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                  _createElementVNode("img", {
                    src: _imports_30,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[66] || (_cache[66] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "2756")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "50",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"50%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                _createElementVNode("img", {
                  src: _imports_31,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[68] || (_cache[68] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, "$120")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
              _createTextVNode("Networking Mixer", -1)
            ]))]),
            _: 1
          }),
          _cache[72] || (_cache[72] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_64, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                  _createElementVNode("img", {
                    src: _imports_32,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_65, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                  _createElementVNode("img", {
                    src: _imports_33,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[73] || (_cache[73] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "1467")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "85",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"85%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[75] || (_cache[75] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, "$120")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
              _createTextVNode("Annual Conference 2024", -1)
            ]))]),
            _: 1
          }),
          _cache[80] || (_cache[80] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_70, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_71, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_72, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[81] || (_cache[81] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "799")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "90",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"90%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_RouterLink, { to: "/events/event-details" }, {
              default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                _createElementVNode("img", {
                  src: _imports_5,
                  class: "rounded-3",
                  alt: "event"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[83] || (_cache[83] = _createElementVNode("div", { class: "bg-white pb-2 ps-2 position-absolute top-0 end-0 rounded-3 rounded-top-0 rounded-end-0 bg-for-dark-mode" }, [
              _createElementVNode("span", { class: "wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-16 fw-bold" }, "$120")
            ], -1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/events/event-details",
            class: "text-secondary text-decoration-none fs-18 fw-bold hover d-block mb-2"
          }, {
            default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
              _createTextVNode("Leadership Summit 2024", -1)
            ]))]),
            _: 1
          }),
          _cache[89] || (_cache[89] = _createElementVNode("p", null, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text. ", -1)),
          _createElementVNode("ul", _hoisted_77, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                  _createElementVNode("img", {
                    src: _imports_6,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_78, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                  _createElementVNode("img", {
                    src: _imports_7,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_79, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                  _createElementVNode("img", {
                    src: _imports_9,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_80, [
              _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                  _createElementVNode("img", {
                    src: _imports_10,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[90] || (_cache[90] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "d-block" }, "Seat Booked"),
              _createElementVNode("span", { class: "fw-medium d-block text-secondary" }, "3241")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "40",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"40%","height":"4px"}
              })
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_81, [
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createVNode(_component_Pagination, {
            items: "10",
            total: "30"
          })
        ])
      ])
    ])
  ]))
}